<template>
  <a-menu
    theme="dark"
    mode="inline"
    :open-keys="openedMenuKeys"
    v-model="currentMenu"
    class="side-menu-wrapper"
    @openChange="onOpenChange"
    style="background-color:rgb(4, 21, 40)"
  >
    <a-sub-menu key="oc_cards" v-if="isShowMenu('menu:customer/oc_cards')">
      <span
        slot="title"
        class="submenu-title-wrapper"
      >
        <a-icon type="pic-center" />
        <span>三方SIM卡管理</span>
      </span>

      <a-menu-item key="oc_sim_cards">
        <router-link :to="{ name: 'oc_sim_cards' }">
          <span>三方SIM卡列表</span>
        </router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu key="queries" v-if="isShowMenu('menu:customer/queries')">
      <span
        slot="title"
        class="submenu-title-wrapper"
      >
        <a-icon type="eye" />
        <span>系统查询</span>
      </span>

      <a-menu-item key="batch_operation_records">
        <router-link :to="{ name: 'batch_operation_records'}">
          <span>批量操作查询</span>
        </router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu key="purchase" v-if="isShowMenu('menu:customer/purchase')">
      <span
        slot="title"
        class="submenu-title-wrapper"
      >
        <a-icon type="lock" />
        <span>采购管理</span>
      </span>
    </a-sub-menu>

    <a-sub-menu key="cards" v-if="isShowMenu('menu:customer/cards')">
      <span
        slot="title"
        class="submenu-title-wrapper"
      >
        <a-icon type="lock" />
        <span>SIM卡管理</span>
      </span>
    </a-sub-menu>

    <a-sub-menu key="smses" v-if="isShowMenu('menu:customer/smses')">
      <span
        slot="title"
        class="submenu-title-wrapper"
      >
        <a-icon type="message" />
        <span>短信管理</span>
      </span>
    </a-sub-menu>

    <a-sub-menu key="sales" v-if="isShowMenu('menu:customer/sales')">
      <span
        slot="title"
        class="submenu-title-wrapper"
      >
        <a-icon type="lock" />
        <span>销售管理</span>
      </span>
    </a-sub-menu>

    <a-sub-menu key="finance" v-if="isShowMenu('menu:customer/finance')">
      <span
        slot="title"
        class="submenu-title-wrapper"
      >
        <a-icon type="lock" />
        <span>财务管理</span>
      </span>
    </a-sub-menu>

    <a-sub-menu key="settings" v-if="isShowMenu('menu:customer/queries')">
      <span
        slot="title"
        class="submenu-title-wrapper"
      >
        <a-icon type="lock" />
        <span>账户设置</span>
      </span>
    </a-sub-menu>
  </a-menu>
</template>

<script>
import { hasPermission } from '@/utils/permission'

export default {
  name: 'SideMenu',
  data() {
    return {
      openedMenuKeys: this.$store.getters.currentMenus, // 当前打开的菜单keys(包含父子菜单)
      rootSubmenuKeys: ['home', 'purchase', 'cards', 'sales', 'finance', 'queries', 'settings']
    }
  },
  computed: {
    // 当前选中的菜单
    currentMenu: {
      get() {
        return this.$store.getters.currentMenus
      },
      set(val) {
        // setActiveMenu 中设置
        // 这里给一个空的 setter, 解决在新标签打开菜单报错问题
      }
    },
    agentType() {
      return parseInt(this.$store.getters.userAgentType)
    }
  },
  watch: {
    $route: {
      handler: function() {
        this.openedMenuKeys = this.currentMenu
      }
    }
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(key => this.openedMenuKeys.indexOf(key) === -1)
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openedMenuKeys = openKeys
      } else {
        this.openedMenuKeys = latestOpenKey ? [latestOpenKey] : []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.side-menu-wrapper {
  border-right-color: transparent;
  height: calc(100vh - 64px);
  overflow: auto;
  -ms-overflow-style: none;

  // 隐藏滚动条
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
